import { useCallback, useEffect, useState } from 'react';
import { companyApi } from '../api/company.api';

// Stored text everywhere (daily report items, invoices...) keeps the real
// company_name; this only maps it to display_name when something is shown.
let cache = null;
let pending = null;

function loadMap() {
  if (cache) return Promise.resolve(cache);
  if (!pending) {
    pending = companyApi.getCompanyList()
      .then((res) => {
        const map = {};
        (Array.isArray(res.data) ? res.data : []).forEach((c) => {
          if (c?.name && c.display_name) map[c.name] = c.display_name;
        });
        cache = map;
        return map;
      })
      .catch(() => ({}))
      .finally(() => { pending = null; });
  }
  return pending;
}

// Returns a function name -> display name (falls back to the name itself).
export function useCompanyDisplay() {
  const [map, setMap] = useState(cache || {});
  useEffect(() => {
    let alive = true;
    loadMap().then((m) => { if (alive) setMap(m); });
    return () => { alive = false; };
  }, []);
  return useCallback((name) => (name && map[name]) || name, [map]);
}
